import React from "react";
import { useNavigate, Link } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();

  // Scroll to Pricing Section
  const scrollDemobooking = () => {
    const section = document.getElementById("section");

    if (section) {
      section.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    } else {
      navigate("/");

      setTimeout(() => {
        const pricingSection = document.getElementById("section");

        if (pricingSection) {
          pricingSection.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }, 700);
    }
  };

  const scrollToAyush = () => {
    const section = document.getElementById("pre-consultation");

    if (section) {
      section.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    } else {
      navigate("/");

      setTimeout(() => {
        const ayushSection = document.getElementById("pre-consultation");

        if (ayushSection) {
          ayushSection.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }, 700);
    }
  };
  return (
    <footer className="relative bg-gray-100 dark:bg-[#0f1117] text-gray-700 dark:text-gray-300 pt-16 overflow-hidden">
      <div
        className="max-w-7xl mx-auto px-6 
        grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 relative z-10"
      >
        {/* LEFT SECTION */}
        <div className="space-y-6">
          <div
            onClick={() => navigate("/")}
            className="flex items-center gap-3 cursor-pointer"
          >
            <div
              className="w-12 h-12 border rounded-full 
              flex items-center justify-center overflow-hidden bg-white"
            >
              <img
                src="../img/logoDarkUpdated.png"
                alt="Logo"
                className="w-full h-full object-cover"
              />
            </div>

            <span className="font-semibold text-lg text-black dark:text-white">
              Clinical AI Assistance
            </span>
          </div>

          <p
            className="text-sm leading-relaxed 
            text-gray-600 dark:text-gray-400 max-w-md"
          >
            A unified AI assistant for outpatient care: pre-visit triage &
            symptom investigation, live documentation, and post-visit guidance.
          </p>
        </div>

        {/* RIGHT LINKS */}
        <div
          className="md:col-span-1 lg:col-span-2 
          grid grid-cols-1 sm:grid-cols-3 gap-8"
        >
          {/* COMPANY */}
          <div>
            <h3 className="font-semibold mb-4 text-black dark:text-white">
              Company
            </h3>

            <ul className="space-y-3 text-sm">
              <li>
                <button
                  onClick={scrollDemobooking}
                  className="inline-block cursor-pointer hover:text-black dark:hover:text-white transition"
                >
                  Try a Demo
                </button>
              </li>

              <li>
                <button
                  onClick={() => navigate("/contact")}
                  className="inline-block cursor-pointer hover:text-black dark:hover:text-white transition"
                >
                   Contact Us
                </button>
              </li>

              <li>
                <button
                  onClick={() => navigate("/TermsAndConditions")}
                  className="inline-block cursor-pointer hover:text-black dark:hover:text-white transition"
                >
                  T&Cs
                </button>
              </li>
            </ul>
          </div>

          {/* PRODUCT */}
          <div>
            <h3 className="font-semibold mb-4 text-black dark:text-white">
              Solution
            </h3>

            <ul className="space-y-3 text-sm">
              <li>
                <Link
                  to="/vision"
                  className="inline-block cursor-pointer hover:text-black dark:hover:text-white transition"
                >
                  R&D
                </Link>
              </li>

              <li>
                <Link
                  onClick={scrollToAyush}
                  className="inline-block cursor-pointer hover:text-black dark:hover:text-white transition"
                >
                  Pre-Consultant
                </Link>
              </li>

              <li>
                <Link
                  to="https://aayushvaani.clinicalaiassistance.com"
                  target="_blank"
                  className="inline-block cursor-pointer hover:text-black dark:hover:text-white transition"
                >
                  Clinical-Scribe
                </Link>
              </li>
            </ul>
          </div>

          {/* RESOURCES */}
          <div>
            <h3 className="font-semibold mb-4 text-black dark:text-white">
              Socials
            </h3>

            <ul className="space-y-3 text-sm">
             

              <li>
                <a
                  href="https://www.linkedin.com/company/clinical-ai-assistance"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block cursor-pointer hover:text-black dark:hover:text-white transition"
                >
                  LinkedIn
                </a>
              </li>

              <li>
                <a
                  href="https://www.facebook.com/ClinicalAIAssistance"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block cursor-pointer hover:text-black dark:hover:text-white transition"
                >
                  Facebook
                </a>
              </li>

              <li>
                <a
                  href="https://twitter.com/_Clinical_AI_/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block cursor-pointer hover:text-black dark:hover:text-white transition"
                >
                  Twitter
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* DOTTED BACKGROUND */}
      <div
        className="mt-12 h-28 pointer-events-none
        bg-[radial-gradient(#9ca3af_1px,transparent_1px)] 
        [background-size:10px_10px] 
        opacity-40 dark:opacity-20"
      />
    </footer>
  );
};

export default Footer;
